import DateSegment from "./DateSegment.js";
import React from "react";
import { jsx } from "react/jsx-runtime";
import { useLocale, useTimeField } from "react-aria";
import { useTimeFieldState } from "react-stately";
//#region src/DatePicker/components/TimeField.tsx
const TimeField = (props) => {
	const { locale } = useLocale();
	const rootRef = React.useRef(null);
	const state = useTimeFieldState({
		...props,
		locale,
		shouldForceLeadingZeros: true
	});
	const { fieldProps } = useTimeField(props, state, rootRef);
	const onFocus = (ev) => {
		props.onFieldFocus?.(ev);
		fieldProps.onFocus?.(ev);
	};
	return /* @__PURE__ */ jsx("div", {
		...fieldProps,
		onFocus,
		ref: rootRef,
		className: "flex",
		children: state.segments.map((segment, i) => /* @__PURE__ */ jsx(DateSegment, {
			segment,
			state,
			size: props.size,
			onClick: onFocus
		}, `segment-${i}}`))
	});
};
//#endregion
export { TimeField as default };

//# sourceMappingURL=TimeField.js.map